

import React, { useEffect, useState, memo } from 'react';
import _get from 'lodash.get';
import _isEmpty from 'lodash.isempty';
import _sortBy from 'lodash.sortby';
import _memoize from 'lodash.memoize';
import { credentials } from '@shootsta/client-auth';
import {
  Text,
  FormModal,
  Dropdown,
  ContentLoader,
  Loader } from
'../../../ui-kit';
import { notify } from '../../Notifications';
import ConfirmationModal from '../../ConfirmationModal';
import AdjustCreditsSection from './AdjustCreditsSection';
import DetailedViewSection from './DetailedViewSection';

import '../styles/_simplified-adjust-credits-modal.scss';



















const Placeholder = () =>
<div className="simplified-adjust-credits-modal__placeholder">
    <ContentLoader width={100} height={26}>
      <rect x="0" y="0" rx="2" ry="2" width="100" height="4" />
      <rect x="0" y="6" rx="2" ry="2" width="100" height="20" />
    </ContentLoader>
  </div>;


function SimplifiedAdjustCreditsModal({
  visible,
  onSave,
  onClose,
  organisation,
  getContractBalance,
  adjustContract,
  getContracts,
  getTeamsContracts,
  updateTeamContracts,
  teamsOnly = false,
  selectedTeamId,
  getProjectsConsumption,
  isInternalMode = false,
  getAdditionalCreditDetails,
  hideBufferOwed = false
}) {
  const [initialLoader, setInitialLoader] = useState(true);
  const [contentLoading, setContentLoading] = useState(false);
  const [recurringMonthly, setRecurringMonthly] = useState(0);
  const [thisMonthOnly, setThisMonthOnly] = useState(0);
  const [topUp, setTopUp] = useState(0);
  const [originalRecurringMonthly, setOriginalRecurringMonthly] = useState(0);
  const [originalThisMonthOnly, setOriginalThisMonthOnly] = useState(0);
  const [originalTopUp, setOriginalTopUp] = useState(0);
  const [selectedBucket, setSelectedBucket] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const [buckets, setBuckets] = useState([]);
  const [workspaceContract, setWorkspaceContract] = useState();
  const [workspaceBucket, setWorkspaceBucket] = useState();
  const [teamContract, setTeamContract] = useState();
  const [contractItemBalances, setContractItemsBalances] = useState([]);
  const [additionalCreditDetails, setAdditionalCreditDetails] = useState([]);
  const [detailedView, setDetailedView] = useState(false);
  const [changeRequest, setChangeRequest] = useState({ reason: '', notes: '' });
  const [shouldAdjustProject, setShouldAdjustProject] = useState(false);
  const [selectedProjectForAdjustment, setSelectedProjectForAdjustment] = useState({});
  const [allTeamsBalances, setAllTeamsCredits] = useState({
    allCredits: 0,
    allTopUpCredits: 0,
    allThisMonthOnlyCreditBalance: 0,
    allThisMonthOnlyCreditConsumption: 0,
    allThisMonthOnlyRecurringBalance: 0,
    allThisMonthOnlyRecurringConsumption: 0,
    allRecurringConsumption: 0,
    allTopupCreditConsumption: 0
  });
  const [teamHasBufferEnabled, setTeamHasBufferEnabled] = useState(false);
  const [teamBufferLimit, setTeamBufferLimit] = useState(0);
  const [showBufferCreditWarning, setShowBufferCreditWarning] = useState(false);
  const [workspaceThisMonthOnly, setWorkspaceThisMonthOnly] = useState(0);

  const { organisationId } = organisation;

  const { original: originalUser } = credentials.get();

  const originalUserEmail = originalUser?.user?.email;

  const handleShowConfirmation = () => {
    setConfirmModal(true);
  };

  const refreshBuckets = async () => {
    if (_isEmpty(contractItemBalances) || _isEmpty(additionalCreditDetails)) {
      return;
    }

    const teamCreditBalances = contractItemBalances.filter((balance) => balance.teamId && balance.type === 'WORKSPACE|CREDITS');
    const teamTopUpBalances = contractItemBalances.filter((balance) => balance.teamId && balance.type === 'WORKSPACE|TOPUP_CREDITS');
    const teamBufferBalances = contractItemBalances.filter((balance) => balance.teamId && balance.type === 'WORKSPACE|BUFFER_CREDITS');

    const allTeamsBalancesBuilder = {
      allCredits: 0,
      allTopUpCredits: 0,
      allThisMonthOnlyCreditBalance: 0,
      allThisMonthOnlyCreditConsumption: 0,
      allThisMonthOnlyRecurringBalance: 0,
      allThisMonthOnlyRecurringConsumption: 0,
      allRecurringConsumption: 0,
      allTopupCreditConsumption: 0
    };

    const teamBuckets = teamCreditBalances.map((creditBalance) => {
      const topUpBalance = teamTopUpBalances.find(
        (teamTopUpBalance) => teamTopUpBalance.teamId === creditBalance.teamId
      ) || { value: 0 };

      const bufferBalance = teamBufferBalances.find(
        (teamBufferBalance) => teamBufferBalance.teamId === creditBalance.teamId
      ) || { value: 0 };

      const {
        balance: thisMonthOnlyBalance,
        consumption: thisMonthOnlyConsumption,
        thisMonthOnlyRecurringBalance,
        thisMonthOnlyRecurringConsumption,
        recurringConsumption
      } = additionalCreditDetails.find(
        (it) => it.teamId === creditBalance.teamId && it.type === 'CREDITS'
      ) || {
        balance: 0,
        consumption: 0,
        thisMonthOnlyRecurringBalance: 0,
        thisMonthOnlyRecurringConsumption: 0,
        recurringConsumption: 0
      };

      const {
        consumption: topupCreditConsumption
      } = additionalCreditDetails.find(
        (it) => it.teamId === creditBalance.teamId && it.type === 'TOPUP_CREDITS'
      ) || { consumption: 0 };

      allTeamsBalancesBuilder.allCredits += creditBalance.value;
      allTeamsBalancesBuilder.allTopUpCredits += topUpBalance.value;
      allTeamsBalancesBuilder.allThisMonthOnlyCreditBalance += thisMonthOnlyBalance;
      allTeamsBalancesBuilder.allThisMonthOnlyCreditConsumption += thisMonthOnlyConsumption;
      allTeamsBalancesBuilder.allThisMonthOnlyRecurringBalance += thisMonthOnlyRecurringBalance;
      allTeamsBalancesBuilder.allThisMonthOnlyRecurringConsumption +=
      thisMonthOnlyRecurringConsumption;
      allTeamsBalancesBuilder.allRecurringConsumption += recurringConsumption;
      allTeamsBalancesBuilder.allTopupCreditConsumption += topupCreditConsumption;

      return {
        label: creditBalance.teamName,
        suffix: `${creditBalance.value + topUpBalance.value} Credits`,
        credit: creditBalance.value,
        topUpCredit: topUpBalance.value,
        topupCreditConsumption,
        teamId: creditBalance.teamId,
        bufferRemaining: bufferBalance.value,
        thisMonthOnlyBalance,
        thisMonthOnlyConsumption,
        thisMonthOnlyRecurringBalance,
        thisMonthOnlyRecurringConsumption,
        recurringConsumption
      };
    });

    setAllTeamsCredits(allTeamsBalancesBuilder);

    const workspaceCreditBalance = contractItemBalances.find(
      (b) => b.type === 'WORKSPACE|CREDITS' && b.product === 'WORKSPACE'
    ) || { value: 0 };

    const workspaceTopUpCreditBalance = contractItemBalances.find(
      (b) => b.type === 'WORKSPACE|TOPUP_CREDITS' && b.product === 'WORKSPACE'
    ) || { value: 0 };

    const workspaceBufferCreditBalance = contractItemBalances.find(
      (b) => b.type === 'WORKSPACE|BUFFER_CREDITS' && b.product === 'WORKSPACE'
    ) || { value: 0 };

    const {
      balance: thisMonthOnlyBalance,
      consumption: thisMonthOnlyConsumption,
      thisMonthOnlyRecurringBalance,
      thisMonthOnlyRecurringConsumption,
      recurringConsumption
    } = additionalCreditDetails.find((it) => it.product === 'WORKSPACE' && it.type === 'CREDITS') ||
    {
      balance: 0,
      consumption: 0,
      thisMonthOnlyRecurringBalance: 0,
      thisMonthOnlyRecurringConsumption: 0,
      recurringConsumption: 0
    };

    const {
      consumption: topupCreditConsumption
    } = additionalCreditDetails.find((it) => it.product === 'WORKSPACE' && it.type === 'TOPUP_CREDITS') ||
    {
      consumption: 0
    };

    const workspaceTotalCreditBalance = workspaceCreditBalance.value +
    workspaceTopUpCreditBalance.value;

    const workspaceBucketObj = {
      suffix: `${workspaceTotalCreditBalance === Infinity ? 'Unlimited' : workspaceTotalCreditBalance} Credits`,
      label: organisation.name ? organisation.name : '-',
      credit: workspaceCreditBalance.value,
      topUpCredit: workspaceTopUpCreditBalance.value,
      teamId: undefined,
      bufferRemaining: workspaceBufferCreditBalance.value,
      thisMonthOnlyBalance,
      thisMonthOnlyConsumption,
      thisMonthOnlyRecurringBalance,
      thisMonthOnlyRecurringConsumption,
      recurringConsumption,
      topupCreditConsumption
    };

    setWorkspaceBucket(workspaceBucketObj);

    const allBuckets = teamsOnly ? teamBuckets : [workspaceBucketObj, ...teamBuckets];
    const selectedTeamBucket = selectedTeamId ?
    teamBuckets.find((it) => it.teamId === selectedTeamId) : teamBuckets[0];
    const initialSelectedBucket = teamsOnly && teamBuckets.length ?
    selectedTeamBucket : workspaceBucketObj;

    setBuckets(_sortBy(allBuckets, 'label'));
    setSelectedBucket(_isEmpty(selectedBucket) ? initialSelectedBucket : selectedBucket);
  };

  const fetchContractBalance = async () => {
    const contractItemBalanceResponse = await getContractBalance({
      organisationId,
      owners: ['WORKSPACE', 'TEAMS'],
      types: ['WORKSPACE|CREDITS', 'WORKSPACE|TOPUP_CREDITS', 'WORKSPACE|BUFFER_CREDITS']
    });

    const contractItemBalancesResp = _get(
      contractItemBalanceResponse,
      'data.getContractItemBalance', []
    ).map((balance) => ({
      ...balance,
      value: Number(balance.value || 0)
    }));

    setContractItemsBalances(contractItemBalancesResp);
  };

  const fetchWorkspaceContract = async () => {
    const contractsResponse = await getContracts({
      organisationId,
      product: 'WORKSPACE',
      status: 'ACTIVE'
    });

    const workspaceContracts = _get(contractsResponse, 'data.getContracts', []);

    setWorkspaceContract(workspaceContracts[0]);
  };

  const fetchTeamContract = async ({ teamId }) => {
    if (!teamId) {
      setTeamContract();
      return;
    }

    const teamsContractResponse = await getTeamsContracts({
      organisationId,
      teamId,
      status: 'ACTIVE'
    });

    const teamContracts = _get(teamsContractResponse, 'data.getTeamContracts', []);

    if (!teamContracts.length) {
      setTeamContract();
      return;
    }

    teamContracts[0].teamId = teamId;

    setTeamContract(teamContracts[0]);
    setTeamBufferLimit(_get(teamContracts[0], 'Payload.subscription.CREDIT_BUFFER_LIMIT', 0));
  };

  const fetchAdditionalCreditDetails = async () => {
    const { data } = await getAdditionalCreditDetails({
      organisationId,
      types: ['CREDITS', 'TOPUP_CREDITS'],
      owners: ['WORKSPACE', 'TEAMS']
    });

    const normalisedAdditionalCredits = _get(data,
    'getAdditionalCreditDetails', []
    ).map((it) => ({
      ...it,
      balance: Number(it.balance || 0),
      consumption: Math.abs(Number(it.consumption || 0)),
      thisMonthOnlyRecurringBalance: it.product &&
      Number(it.thisMonthOnlyRecurringBalance || 0) < 0 ?
      0 : Number(it.thisMonthOnlyRecurringBalance || 0),
      thisMonthOnlyRecurringConsumption: Math.abs(
        Number(it.thisMonthOnlyRecurringConsumption || 0)
      ),
      recurringConsumption: Math.abs(Number(it.recurringConsumption || 0))
    }));

    setAdditionalCreditDetails(normalisedAdditionalCredits);
  };

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
      fetchWorkspaceContract(),
      fetchContractBalance(),
      fetchAdditionalCreditDetails()]
      );
      setInitialLoader(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    fetchTeamContract({ teamId: selectedBucket?.teamId });
  }, [selectedBucket?.teamId]);

  useEffect(() => {
    refreshBuckets();
  }, [contractItemBalances, workspaceContract, teamContract, additionalCreditDetails]);

  const handleOrgCredits = () => {
    const monthlyRecurringValue = workspaceContract?.
    Payload.subscription.CONTRACT_LINE_ITEMS.CREDITS || 0;
    const thisMonthOnlyBalance = buckets.find((bucket) => !bucket?.teamId)?.thisMonthOnlyBalance;
    const thisMonthOnlyConsumption = buckets.
    find((bucket) => !bucket?.teamId)?.
    thisMonthOnlyConsumption;
    const topUpValue = buckets.find((bucket) => !bucket?.teamId)?.topUpCredit;
    const topUpConsumption = buckets.find((bucket) => !bucket?.teamId)?.topupCreditConsumption;

    const thisMonthOnlyValue = thisMonthOnlyBalance +
    thisMonthOnlyConsumption +
    allTeamsBalances.allThisMonthOnlyCreditBalance +
    allTeamsBalances.allThisMonthOnlyCreditConsumption;

    const allTopupValue = topUpValue +
    topUpConsumption +
    allTeamsBalances.allTopUpCredits +
    allTeamsBalances.allTopupCreditConsumption;

    setWorkspaceThisMonthOnly(thisMonthOnlyValue);

    setOriginalRecurringMonthly(Number(monthlyRecurringValue) || 0);
    setOriginalThisMonthOnly(thisMonthOnlyValue || 0);
    setOriginalTopUp(allTopupValue || 0);

    setRecurringMonthly(Number(monthlyRecurringValue) || 0);
    setThisMonthOnly(thisMonthOnlyValue || 0);
    setTopUp(allTopupValue || 0);
  };

  const handleTeamCredits = () => {
    const monthlyRecurringValue = teamContract?.Payload.subscription.CONTRACT_LINE_ITEMS['WORKSPACE|CREDITS'] || 0;
    const topUpValue = buckets.find(
      (bucket) => bucket?.teamId === teamContract?.teamId
    )?.topUpCredit;
    const topUpConsumption = buckets.find(
      (bucket) => bucket?.teamId === teamContract?.teamId
    )?.topupCreditConsumption;
    const teamThisMonthOnlyBalance = buckets.find(
      (bucket) => bucket?.teamId === teamContract?.teamId
    )?.thisMonthOnlyBalance;
    const teamThisMonthOnlyConsumption = buckets.find(
      (bucket) => bucket?.teamId === teamContract?.teamId
    )?.thisMonthOnlyConsumption;
    const teamThisMonthOnlyRecurringBalance = buckets.find(
      (bucket) => bucket?.teamId === teamContract?.teamId
    )?.thisMonthOnlyRecurringBalance;
    const teamThisMonthOnlyRecurringConsumption = buckets.find(
      (bucket) => bucket?.teamId === teamContract?.teamId
    )?.thisMonthOnlyRecurringConsumption;

    const thisMonthOnlyValue = teamThisMonthOnlyBalance +
    teamThisMonthOnlyConsumption +
    teamThisMonthOnlyRecurringBalance +
    teamThisMonthOnlyRecurringConsumption;
    const allTopupValue = topUpValue + topUpConsumption;

    setOriginalRecurringMonthly(Number(monthlyRecurringValue) || 0);
    setOriginalThisMonthOnly(thisMonthOnlyValue || 0);
    setOriginalTopUp(allTopupValue || 0);

    setRecurringMonthly(Number(monthlyRecurringValue) || 0);
    setThisMonthOnly(thisMonthOnlyValue || 0);
    setTopUp(allTopupValue || 0);
    const isEnabled = teamContract?.Payload.subscription.ENABLE_CREDIT_BUFFER || false;
    setTeamHasBufferEnabled(isEnabled);

    if (!isEnabled) {
      return;
    }

    const limit = teamContract?.Payload.subscription.CREDIT_BUFFER_LIMIT || 0;
    setTeamBufferLimit(limit);
  };

  useEffect(() => {
    setContentLoading(false);

    if (!teamContract?.teamId) {
      handleOrgCredits();
      return;
    }

    handleTeamCredits();
  }, [buckets, teamContract]);

  const onBucketChange = (bucket) => {
    setContentLoading(true);
    setSelectedBucket(bucket);
  };

  const onCloseConfirmModal = () => {
    setConfirmModal(false);
    onClose();
  };

  const openBufferCreditWarning = () => {
    setShowBufferCreditWarning(true);
  };

  const closeBufferCreditWarning = () => {
    setShowBufferCreditWarning(false);
  };

  const bufferWarningSubtitle = () =>
  <Text>
      You have run out of Advance credits for your workspace.
      Please get in touch with your Account Manager to increase
      the Credit Advance limit. Alternatively, you can disable Credit Advance and continue.
    </Text>;


  const onConfirmModal = async () => {
    const changesMade = {
      recurringMonthly: 0,
      thisMonthOnly: 0,
      topUp: 0
    };

    if (selectedBucket.teamId && recurringMonthly !== originalRecurringMonthly) {
      const { Payload } = teamContract || { Payload: {} };

      const { data, error } = await updateTeamContracts({
        organisationId,
        inputs: [{
          teamId: selectedBucket.teamId,
          payload: {
            ...Payload,
            subscription: {
              ...Payload.subscription,
              // This ensures it gets set to the changed recurring value
              CREDIT_BUFFER_LIMIT: undefined,
              CONTRACT_LINE_ITEMS: {
                ...Payload.subscription.CONTRACT_LINE_ITEMS,
                'WORKSPACE|CREDITS': recurringMonthly
              }
            }
          }
        }],
        ghosteeUserEmail: originalUserEmail
      });

      if (!data || error) {
        notify({ content: 'Something went wrong updating recurring balance.', type: 'error' });
      } else {
        notify({
          title: 'Changes to Recurring Balance Successfully Saved!',
          content: 'Recurring credit balance(s) have been updated.',
          type: 'success'
        });
        changesMade.recurringMonthly = recurringMonthly;
      }
    }

    if (thisMonthOnly !== originalThisMonthOnly) {
      const adjustAmount = thisMonthOnly - originalThisMonthOnly;

      const { error, data } = await adjustContract({
        organisationId,
        owner: selectedBucket && selectedBucket.teamId ?
        `TEAM|${selectedBucket.teamId}` :
        'WORKSPACE',
        type: 'WORKSPACE|CREDITS',
        amount: adjustAmount,
        reason: changeRequest.reason,
        notes: changeRequest.notes,
        adjustFor: selectedProjectForAdjustment?.resourceId ? `PRO|${selectedProjectForAdjustment?.resourceId}` : '',
        ghosteeUserEmail: originalUserEmail
      });

      if (!data || error) {
        notify({
          content: 'Something went wrong updating this month only balance.',
          type: 'error'
        });
      } else {
        notify({
          title: 'Changes to This Month Only Balance Successfully Saved!',
          content: 'This month only credit balance(s) have been updated.',
          type: 'success'
        });
        changesMade.thisMonthOnly = adjustAmount;
      }
    }

    if (topUp !== originalTopUp) {
      const adjustAmount = topUp - originalTopUp;

      const { error, data } = await adjustContract({
        organisationId,
        owner: selectedBucket && selectedBucket.teamId ?
        `TEAM|${selectedBucket.teamId}` :
        'WORKSPACE',
        type: 'WORKSPACE|TOPUP_CREDITS',
        amount: adjustAmount,
        reason: changeRequest.reason,
        notes: changeRequest.notes,
        adjustFor: selectedProjectForAdjustment?.resourceId ? `PRO|${selectedProjectForAdjustment?.resourceId}` : '',
        ghosteeUserEmail: originalUserEmail
      });

      if (!data || error) {
        notify({ content: 'Something went wrong updating Flex balance.', type: 'error' });
      } else {
        notify({ title: 'Changes to Flex Credits Successfully Saved!',
          content: 'Flex credit balance(s) have been updated.',
          type: 'success'
        });
        changesMade.topUp = adjustAmount;
      }
    }

    onSave(changesMade);
    onCloseConfirmModal();
  };

  const toggleDetailedView = () => {
    setDetailedView(!detailedView);
  };

  const toggleShouldAdjustProject = () => {
    setShouldAdjustProject(!shouldAdjustProject);
  };

  const {
    credit: workspaceCredits = 0,
    topUpCredit: workspaceTopUpCredits = 0,
    bufferRemaining: workspaceBufferCreditsRemaining = 0,
    thisMonthOnlyBalance: workspaceThisMonthOnlyBalance = 0,
    thisMonthOnlyRecurringBalance: workspaceThisMonthOnlyRecurringBalance = 0
  } = workspaceBucket || {};

  const workspaceRecurringBalance = workspaceCredits === Infinity ?
  'Unlimited' :
  `${workspaceCredits - workspaceThisMonthOnlyBalance - workspaceThisMonthOnlyRecurringBalance}`;

  const usageThisMonthOnlyForTeamsDelta = thisMonthOnly - originalThisMonthOnly;
  const orgRecurringMonthlyUsage = originalRecurringMonthly - recurringMonthly;
  const orgRecurringMonthlyUpdatedUsage = Number.isNaN(orgRecurringMonthlyUsage) ?
  0 : orgRecurringMonthlyUsage;

  const usedCredits = {
    usageOfWorkspaceCredits: selectedBucket.teamId ?
    recurringMonthly - originalRecurringMonthly :
    orgRecurringMonthlyUpdatedUsage,
    usageOfTopUpCredits: selectedBucket.teamId ?
    topUp - originalTopUp :
    originalTopUp - topUp,
    usageOfThisMonthOnlyCredits: selectedBucket.teamId ?
    usageThisMonthOnlyForTeamsDelta :
    originalThisMonthOnly - thisMonthOnly
  };

  const hasChangesApartFromRecurring = thisMonthOnly !== originalThisMonthOnly ||
  topUp !== originalTopUp;

  const wsRecurringVal = workspaceContract?.Payload.subscription.CONTRACT_LINE_ITEMS.CREDITS || 0;
  const wsBufferLimit = workspaceContract?.Payload.subscription.CREDIT_BUFFER_LIMIT || 0;
  const isWsFreeTier = workspaceContract?.Payload?.subscription?.TIER === 'FREE';

  const onChangeTeamRecurring = (value) => {
    const isRecurringChanged = originalRecurringMonthly !== value;
    const differenceAmount = value - originalRecurringMonthly;
    const isIncremented = value - originalRecurringMonthly > 0;
    if (
    teamHasBufferEnabled &&
    isRecurringChanged &&
    isIncremented &&
    differenceAmount > workspaceBufferCreditsRemaining)
    {
      openBufferCreditWarning();
      return;
    }

    setRecurringMonthly(value);
  };

  const isConfirmDisabled = _memoize((
  hasChangesApartFromRecurringVal,
  teamsOnlyVal,
  changeRequestVal,
  recurringMonthlyVal,
  originalRecurringMonthlyVal) =>
  {
    // If there are changes to top up or this month only, enable if
    // 1.) You're on the teamsOnly view (no reason field showable) or
    // 2.) A reason has been selected
    if (hasChangesApartFromRecurringVal && (teamsOnlyVal || changeRequestVal.reason)) {
      return false;
    }

    // If there are no other changes, but recurring has changed, always
    // enable as no reason is required in either view for recurring changes
    if (!hasChangesApartFromRecurringVal && recurringMonthlyVal !== originalRecurringMonthlyVal) {
      return false;
    }

    // In all other cases, disable the button
    return true;
  });

  if (initialLoader) {
    return (
      <FormModal
        visible={visible}
        hideFooter
        showHeaderCloseButton={false}>

        <Loader
          hasNoBeforeShowTimeout
          text="Fetching Credit Details"
          caption="Please wait while we fetch credit details for you" />

      </FormModal>);

  }

  const renderCreditsSection = () => {
    if (contentLoading) {
      return <Placeholder />;
    }

    return (
      <>
        <AdjustCreditsSection
          organisationId={organisationId}
          detailedView={detailedView}
          toggleDetailedView={toggleDetailedView}
          usedCredits={usedCredits}
          selectedBucket={selectedBucket}
          onChangeTeamRecurring={onChangeTeamRecurring}
          setThisMonthOnly={setThisMonthOnly}
          setTopUp={setTopUp}
          recurringMonthly={recurringMonthly}
          originalRecurringMonthly={originalRecurringMonthly}
          thisMonthOnly={thisMonthOnly}
          originalThisMonthOnly={originalThisMonthOnly}
          topUp={topUp}
          originalTopUp={originalTopUp}
          workspaceCredits={workspaceCredits}
          workspaceTopUpCredits={workspaceTopUpCredits}
          hasChangesApartFromRecurring={hasChangesApartFromRecurring}
          teamsOnly={teamsOnly}
          shouldAdjustProject={shouldAdjustProject}
          toggleShouldAdjustProject={toggleShouldAdjustProject}
          setSelectedProjectForAdjustment={setSelectedProjectForAdjustment}
          changeRequest={changeRequest}
          setChangeRequest={setChangeRequest}
          getProjectsConsumption={getProjectsConsumption}
          allTeamsBalances={allTeamsBalances} // all teams balances and consumption in workspace
          workspaceThisMonthOnlyBalance={workspaceThisMonthOnlyBalance} // workspace this month only balance
          workspaceRecurringBalance={workspaceRecurringBalance} // workspace recurring credits without this month only
          isInternalMode={isInternalMode} // distinguish between internal mode and workspace for adjust credits
          isWsFreeTier={isWsFreeTier} // is workspace on free tier
          wsRecurringVal={Number(wsRecurringVal)} // workspace contract recurring credit value
          teamBufferLimit={teamBufferLimit} // selected team buffer limit
        />

        {(detailedView || !isInternalMode) &&
        <DetailedViewSection
          usedCredits={usedCredits}
          workspaceRecurringBalance={workspaceRecurringBalance}
          wsRecurringVal={Number(wsRecurringVal)}
          wsBufferLimit={wsBufferLimit}
          originalRecurringMonthly={originalRecurringMonthly}
          workspaceBufferCreditsRemaining={workspaceBufferCreditsRemaining}
          originalThisMonthOnly={originalThisMonthOnly}
          workspaceTopUpCredits={workspaceTopUpCredits}
          originalTopUp={originalTopUp}
          teamHasBufferEnabled={teamHasBufferEnabled}
          selectedBucket={selectedBucket}
          allTeamsBalances={allTeamsBalances}
          teamBufferLimit={teamBufferLimit}
          isInternalMode={isInternalMode}
          workspaceThisMonthOnlyBalance={workspaceThisMonthOnlyBalance}
          hideBufferOwed={hideBufferOwed}
          workspaceThisMonthOnly={workspaceThisMonthOnly} />}


      </>);

  };

  return (
    <>
      <FormModal
        visible={visible}
        onClose={onClose}
        title="Adjust Credits"
        subtitle={!isInternalMode && 'Allocate credits between workspace and teams'}
        saveText="Confirm Changes"
        onSave={handleShowConfirmation}
        className="simplified-adjust-credits-modal"
        isFullWidth
        organisation={organisation}
        saveDisabled={isConfirmDisabled(
          hasChangesApartFromRecurring,
          teamsOnly,
          changeRequest,
          recurringMonthly,
          originalRecurringMonthly
        )}
        stayOpenOnSave>

        <>
          <Text heading5 required>
            {isInternalMode ? 'Which bucket do you want to adjust credits from?' : 'Selection'}
          </Text>

          <Dropdown
            disabled={buckets.length === 1}
            defaultValue={selectedBucket}
            value={selectedBucket}
            onChange={(bucket) => onBucketChange(bucket)}
            options={buckets}
            showSelectedSuffix
            type="BUTTON" />

          {renderCreditsSection()}
        </>
      </FormModal>
      <FormModal
        visible={confirmModal}
        onClose={onCloseConfirmModal}
        title="Are you sure?"
        saveText="Confirm"
        onSave={onConfirmModal}>

        <Text>
          The workspace Admin will be notified of this change.
        </Text>
      </FormModal>
      {showBufferCreditWarning &&
      <ConfirmationModal
        visible={showBufferCreditWarning}
        onSave={closeBufferCreditWarning}
        hideCancelBtn
        saveBtnText="Confirm"
        title="Low Credit Advance Balance"
        subtitle={bufferWarningSubtitle()} />}


    </>);

}

export default memo(SimplifiedAdjustCreditsModal);